import { render, staticRenderFns } from "./page-title-operate.vue?vue&type=template&id=70392eea&"
import script from "./page-title-operate.vue?vue&type=script&lang=js&"
export * from "./page-title-operate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports